var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 33,
    viewBox: "0 0 88 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.93 32.025H28.54V26.135C26.94 28.755 21.76 32.025 16 32.025C7.23 32.025 0 24.725 0 16.025C0 7.32496 7.23 0.0849609 16 0.0849609C21.76 0.0849609 26.94 3.28496 28.54 5.90496V0.14496H31.93V32.015V32.025ZM28.54 16.025C28.54 9.04496 22.97 3.48496 16 3.48496C9.03 3.48496 3.39001 9.05496 3.39001 16.025C3.39001 22.995 8.96 28.635 16 28.635C23.04 28.635 28.54 23.065 28.54 16.025Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7297 11.57V32.11H84.3397V11.57C84.3397 6.96 81.1397 3.38 76.9197 3.38C72.6997 3.38 69.5597 6.96 69.5597 11.57V32.11H66.0997V11.57C66.0997 6.96 62.8997 3.38 58.7397 3.38C54.5797 3.38 51.3197 6.96 51.3197 11.57V32.11H47.9297V11.57C47.9297 10.93 47.9897 10.42 47.9897 10.61L47.9297 0.18L51.3197 0.12L51.3797 2.94C52.1497 1.79 55.2797 0 58.7397 0C62.8997 0 66.6797 2.69 67.8297 5.25C68.9797 2.69 72.7597 0 76.9197 0C82.8097 0 87.7297 5.25 87.7297 11.58V11.57Z",
    fill: "transparent"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAm);
export default __webpack_public_path__ + "static/media/AM.58c14573dbd59aa560bd9873b76b6a80.svg";
export { ForwardRef as ReactComponent };